import { useCallback } from 'react';
import { useLocation } from 'react-router-dom';

import { useAppSelector } from '@/redux/hooks';
import { getDeployment } from '@/redux/modules/config';
import { track } from '@/utils/amplitude/analytics/core';
import { AccountDetailsEventFlow, TrackingEvents, TrackingPayload } from '@/utils/amplitude/analytics/core.types';
import { getFullUrl } from '@/utils/amplitude/analytics/utils/getFullUrl';
import { getAmplitudePageNameFromPath } from '@/utils/getPageNameFromPath';

type VerifyYourAddressViewedPayload = TrackingPayload & {
    eventFlow: AccountDetailsEventFlow;
};

const trackVerifyYourAddressViewed = (payload: VerifyYourAddressViewedPayload) => {
    track(TrackingEvents.Account.VerifyYourAddressViewed, payload);
};

export const useTrackVerifyYourAddressedViewed = (eventFlow: AccountDetailsEventFlow) => {
    const deployment = useAppSelector(getDeployment);
    const { pathname } = useLocation();

    return useCallback(() => {
        trackVerifyYourAddressViewed({
            eventFlow,
            pageName: getAmplitudePageNameFromPath(pathname),
            url: getFullUrl(deployment, pathname),
        });
    }, [deployment, eventFlow, pathname]);
};
